<template>
  <footer class="axon-footer">
    <div class="axon-footer-inner">
      <div class="axon-footer-brand">
        <AxonLogo class="axon-footer-mark" />
        <div class="axon-footer-brand-text">
          <span class="axon-footer-tagline">{{ localize('AXON_FOOTER_TAGLINE') }}</span>
        </div>
      </div>

      <nav class="axon-footer-nav" aria-label="Footer">
        <a class="axon-footer-link" @click="scrollTo('services')">{{ localize('AXON_NAV_SERVICES') }}</a>
        <a class="axon-footer-link" @click="scrollTo('contact')">{{ localize('AXON_NAV_CONTACT') }}</a>
        <a class="axon-footer-link" @click="$emit('showTerms')">
          {{ isLang('ja') > -1 ? '利用規約' : 'Terms' }}
        </a>
      </nav>
    </div>

    <div class="axon-footer-rule" aria-hidden="true" />

    <div class="axon-footer-meta">
      <span class="axon-footer-copy">© 2026 Pitts Health. All rights reserved.</span>
      <span class="axon-footer-locale">Riyadh · KSA</span>
    </div>
  </footer>
</template>

<script>
import { translationStore } from "@/stores/translation";
import AxonLogo from "./AxonLogo.vue";

export default {
  name: "SVFooter",
  components: { AxonLogo },
  emits: ["showTerms"],
  setup() {
    const translation = translationStore();
    const isLang = (lang) => translation.getLang().indexOf(lang);
    const scrollTo = (id) => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    return { localize: translation.localize, isLang, scrollTo };
  },
};
</script>

<style scoped>
.axon-footer {
  background: var(--axon-ink-050, #F6F7F6);
  color: var(--axon-ink-700, #2A322D);
  font-family: var(--axon-font-body, 'Inter', sans-serif);
  border-top: 1px solid var(--axon-ink-100, #E6E9E7);
  padding: 56px 32px 28px;
}
.axon-footer-inner {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
}
.axon-footer-brand {
  display: flex;
  align-items: center;
  gap: 14px;
}
.axon-footer-mark {
  height: 54px;
  width: auto;
  flex: 0 0 auto;
}
.axon-footer-brand-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.axon-footer-word {
  font-family: var(--axon-font-display, 'Manrope', sans-serif);
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.22em;
  color: var(--axon-ink-900, #0A0F0C);
  line-height: 1;
}
.axon-footer-tagline {
  font-size: 0.82rem;
  color: var(--axon-ink-500, #5C6660);
  letter-spacing: 0.005em;
}
.axon-footer-nav {
  display: flex;
  gap: 28px;
  align-items: center;
}
.axon-footer-link {
  font-size: 0.88rem;
  font-weight: 500;
  color: var(--axon-ink-700, #2A322D);
  cursor: pointer;
  text-decoration: none;
  letter-spacing: -0.005em;
  transition: color 200ms ease;
}
.axon-footer-link:hover {
  color: var(--axon-blue-600, #1E6FB0);
}
.axon-footer-rule {
  max-width: 1280px;
  margin: 32px auto 18px;
  border-top: 1px solid var(--axon-ink-100, #E6E9E7);
}
.axon-footer-meta {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.78rem;
  color: var(--axon-ink-500, #5C6660);
  letter-spacing: 0.01em;
}
.axon-footer-copy {
  flex: 1;
}
.axon-footer-locale {
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--axon-ink-500, #5C6660);
}

@media (max-width: 720px) {
  .axon-footer {
    padding: 40px 22px 22px;
  }
  .axon-footer-inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }
  .axon-footer-nav {
    gap: 22px;
    flex-wrap: wrap;
  }
  .axon-footer-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
}
</style>
